import { CROSS_DOMAIN_PARAMS } from '@provider-directory/components/analytics/analytics-provider';

/**
 * Removes cross-domain tracking parameters from a URLSearchParams object
 * @param searchParams - The URLSearchParams object to clean
 * @returns A new URLSearchParams object with tracking parameters removed
 */
export const withoutTrackingParams = (
  searchParams: URLSearchParams,
): URLSearchParams => {
  const cleanedParams = new URLSearchParams(searchParams);

  CROSS_DOMAIN_PARAMS.forEach((param) => {
    cleanedParams.delete(param);
  });

  return cleanedParams;
};
